import { OrganizationDatabaseContextType } from './types'
import { createContext } from 'use-context-selector'
export const OrganizationDatabaseContext = createContext(
  {} as OrganizationDatabaseContextType
)
